<template>
  <div></div>
</template>

<script>
export default {
  name: 'mdgk'
}
</script>

<style scoped>

</style>
